import React, { useState } from "react";
import { Typography, Modal } from "antd";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
} from "recharts";

const { Title } = Typography;

export default function TotalEmployees() {
  const organisationwise = {
    BFMS: { male: 100, female: 200 },
    BVPL: { male: 200, female: 80 },
    BCPL: { male: 300, female: 50 },
  };

  // Convert data to array format for chart
  const chartData = Object.keys(organisationwise).map((org) => ({
    organisation: org,
    Male: organisationwise[org].male,
    Female: organisationwise[org].female,
  }));

  const [selectedOrg, setSelectedOrg] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const COLORS = ["#1890ff", "#eb2f96"]; // blue and pink

  const handleBarClick = (data) => {
    if (data && data.activeLabel) {
      setSelectedOrg(data.activeLabel);
      setIsModalOpen(true);
    }
  };

  const selectedOrgData =
    selectedOrg && organisationwise[selectedOrg]
      ? [
          { name: "Male", value: organisationwise[selectedOrg].male },
          { name: "Female", value: organisationwise[selectedOrg].female },
        ]
      : [];

  return (
    <>
      <ResponsiveContainer width="100%" height={220}>
        <BarChart
          data={chartData}
          margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
          onClick={handleBarClick}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="organisation" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="Male" stackId="a" fill="#1890ff" />
          <Bar dataKey="Female" stackId="a" fill="#eb2f96" />
        </BarChart>
      </ResponsiveContainer>
      <center><Title level={5}>Employee Gender Distribution</Title></center>

      <Modal
        title={`Gender Ratio - ${selectedOrg}`}
        open={isModalOpen}
        footer={null}
        onCancel={() => setIsModalOpen(false)}
        centered
        
      >
        <ResponsiveContainer width="100%" height={300}>
          <PieChart>
            <Pie
              data={selectedOrgData}
              dataKey="value"
              nameKey="name"
              cx="50%"
              cy="50%"
              outerRadius={100}
              label={(entry) => `${entry.name}: ${entry.value}`}
            >
              {selectedOrgData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
              ))}
            </Pie>
            <Tooltip />
          </PieChart>
        </ResponsiveContainer>
      </Modal>
    </>
  );
}
